import React from 'react';
import {
  FiInfo,
  FiCheckCircle,
  FiAlertTriangle,
  FiXCircle,
  FiX,
} from 'react-icons/fi';

/**
 * Inline message box. Tinted background mirrors the design's pill-soft
 * tokens (12% opacity over a saturated color) so a single color reads in
 * both themes without bespoke dark variants.
 */
const VARIANTS = {
  info: {
    container:
      'bg-[rgba(59,130,246,0.10)] border-[rgba(59,130,246,0.30)] text-[#1d4ed8] dark:text-[#93c5fd]',
    icon: <FiInfo className="w-5 h-5 text-[#3b82f6]" />,
  },
  success: {
    container: 'bg-success-soft border-[rgba(16,185,129,0.30)] text-success',
    icon: <FiCheckCircle className="w-5 h-5 text-success" />,
  },
  warning: {
    container: 'bg-warning-soft border-[rgba(245,158,11,0.30)] text-warning',
    icon: <FiAlertTriangle className="w-5 h-5 text-warning" />,
  },
  error: {
    container: 'bg-error-soft border-[rgba(239,68,68,0.30)] text-error',
    icon: <FiXCircle className="w-5 h-5 text-error" />,
  },
};

export default function Alert({
  variant = 'info',
  title,
  dismissible = false,
  onDismiss,
  className = '',
  children,
}) {
  const v = VARIANTS[variant] ?? VARIANTS.info;
  return (
    <div
      role="alert"
      className={`flex items-start gap-3 px-4 py-3 rounded-md border ${v.container} ${className}`}
    >
      <div className="shrink-0 mt-0.5">{v.icon}</div>
      <div className="flex-1 min-w-0">
        {title ? (
          <p className="font-semibold text-sm leading-5">{title}</p>
        ) : null}
        {children ? (
          <div className={`text-sm leading-5 ${title ? 'mt-0.5' : ''}`}>
            {children}
          </div>
        ) : null}
      </div>
      {dismissible ? (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="shrink-0 p-1 -m-1 rounded hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
        >
          <FiX className="w-4 h-4" />
        </button>
      ) : null}
    </div>
  );
}
